export default "__VITE_ASSET__C5gLJ1oy__"